<template>
  <div />
</template>

<script>
import { mapActions } from 'vuex'

export default {
  async created () {
    if (this.$route.query.access_token) {
      const accessToken = this.$route.query.access_token
      const id = this.$route.query.id
      const ed = this.$route.query.ed
      this.$cookies.set('TID', id)
      this.$cookies.set('TTT', 'Bearer')
      this.$cookies.set('TAT', accessToken)
      this.$cookies.set('TED', ed)

      // Fetch user info from point
      try {
        const pointUser = await this.fetchPointUser()
        const authUser = await this.fetchUser(pointUser)
        const localProjectId = parseFloat(localStorage.getItem('projectId'))
        if (pointUser.projects.length > 0) {
          for (let i = 0; i < pointUser.projects.length; i++) {
            const project = pointUser.projects[i]
            const defaultProject = await this.fetchProject({
              user_id: authUser.id,
              external_user_id: pointUser.id,
              external_id: 1, // TODO: currently available from point
              external_ref_id: project.id,
              project_name: project.name,
              owner_id: project.owner_id
            })
            if (defaultProject.id === localProjectId) {
              this.$store.commit('auth/UPDATE_PROJECT', defaultProject)
            } else if (i === 0) {
              this.$store.commit('auth/UPDATE_PROJECT', defaultProject)
            }
            localStorage.setItem('projectId', defaultProject.id)
          }

          this.findUser({
            id: authUser.id,
            params: {
              project_id: localStorage.getItem('projectId')
            }
          })
        } else {
          // There is no project
          this.$router.push({ name: 'Login', query: { error: 'Project not found' } })
          return
        }
        if (this.$route.query.r) {
          this.$router.replace(this.$route.query.r)
        } else {
          this.$router.push('/')
        }
      } catch (error) {
        console.log(error)
        this.$router.push({ name: 'Login', query: { error: 'Login failed' } })
      }
    } else {
      this.$router.push('/login')
    }
  },
  methods: {
    ...mapActions('auth', {
      fetchUser: 'fetch',
      findUser: 'find'
    }),
    ...mapActions('point', {
      fetchPointUser: 'fetch'
    }),
    ...mapActions('project', {
      fetchProject: 'fetch'
    })
  }
}
</script>
